import { useErrorHandlingSlice } from 'app/error/slice';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import useApi from 'services/mavapi/useApi';
import {
    RegistrationReportSummary,
    RegistrationService,
    RecordManualPaymentRequest,
} from 'services/openapi';

export const useRegistrationReport = () => {
    const {
        registrationExportRegistrationReport,
        registrationGetRegistrationReport,
        registrationRecordManualPayment
    } = RegistrationService;
    const [loading, setLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const dispatch = useDispatch();
    const { actions } = useErrorHandlingSlice();
    const [registrationReportData, setRegistrationReportData] =
        useState<RegistrationReportSummary>();
    const [, setError] = useState<unknown | null>();
    const { error: apiError, handleRequest } = useApi();

    // Filter and pagination state
    const [type, setType] = useState<string>('');
    const [fromDate, setFromDate] = useState<string>('');
    const [toDate, setToDate] = useState<string>('');
    const [searchName, setSearchName] = useState<string>('');
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(50);

    const fetchRegistrationReport = (
        filterType?: string,
        filterFromDate?: string,
        filterToDate?: string,
        filterSearchName?: string,
        filterPageNumber: number = 1,
        filterPageSize: number = 50,
    ) => {
        setLoading(true);
        console.log(searchName, 'searchName', filterSearchName)
        // Update filter state
        if (filterType !== undefined) setType(filterType);
        if (filterFromDate !== undefined) setFromDate(filterFromDate);
        if (filterToDate !== undefined) setToDate(filterToDate);
        if (filterSearchName !== undefined) setSearchName(filterSearchName);
        setPageNumber(filterPageNumber);
        setPageSize(filterPageSize);

        handleRequest(
            registrationGetRegistrationReport(
                filterType !== undefined ? filterType : type,
                filterFromDate !== undefined ? filterFromDate : fromDate,
                filterToDate !== undefined ? filterToDate : toDate,
                filterSearchName !== undefined ? filterSearchName : searchName,
                filterPageNumber,
                filterPageSize,
            ),
        )
            .then(res => {
                if (res) {
                    setRegistrationReportData(res);
                }
                setLoading(false);
            })
            .catch(() => {
                setError(apiError);
                setLoading(false);
            });
    };

    const downloadRegistrationReport = (
        filterType?: string,
        filterFromDate?: string,
        filterToDate?: string,
        filterSearchName?: string,
    ) => {
        setDownloadLoading(true);
        return new Promise((resolve, reject) => {
            handleRequest(
                registrationExportRegistrationReport(
                    filterType || type,
                    filterFromDate || fromDate,
                    filterToDate || toDate,
                    filterSearchName || searchName,
                ),
            )
                .then(res => {
                    dispatch(
                        actions.dispatchToast({
                            errorTxt: 'Downloaded Successfully',
                            show: true,
                            errorType: 'success',
                        }),
                    );
                    resolve(res);
                    setDownloadLoading(false);
                })
                .catch(() => {
                    setDownloadLoading(false);
                    reject(apiError);
                });
        });
    };

    const recordManualPayment = (paymentData: RecordManualPaymentRequest) => {
        return new Promise((resolve, reject) => {
            handleRequest(registrationRecordManualPayment(paymentData))
                .then(res => {
                    dispatch(
                        actions.dispatchToast({
                            errorTxt: 'Payment recorded successfully',
                            show: true,
                            errorType: 'success',
                        }),
                    );
                    resolve(res);
                })
                .catch(() => {
                    dispatch(
                        actions.dispatchToast({
                            errorTxt: 'Failed to record payment',
                            show: true,
                            errorType: 'error',
                        }),
                    );
                    reject(apiError);
                });
        });
    };

    return {
        fetchRegistrationReport,
        registrationReportData,
        loading,
        downloadRegistrationReport,
        downloadLoading,
        recordManualPayment,
        // Filter state
        type,
        setType,
        fromDate,
        setFromDate,
        toDate,
        setToDate,
        searchName,
        setSearchName,
        pageNumber,
        setPageNumber,
        pageSize,
        setPageSize,
    };
};
